import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ICustomProperties } from '@microsoft/applicationinsights-core-js';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app.config';
import { Md5 } from 'ts-md5/dist/md5';

/* https://devblogs.microsoft.com/premier-developer/angular-how-to-add-application-insights-to-an-angular-spa/
*/
@Injectable()
export class LoggingService {
    private readonly appInsights: ApplicationInsights;
    constructor() {
        this.appInsights = new ApplicationInsights({
            config: {
                connectionString: AppConfig.appInsightsConnectionString,
            }
        });
        this.appInsights.loadAppInsights();
    }

    /* https://dev.azure.com/miljoeportal/GrundRisk/_wiki/wikis/Grundrisk%20MVP%20Wiki/4115/DMP-logging-in-Grundrisk
        https://miljoeportal.visualstudio.com/Logning/_wiki/wikis/Logning.wiki/1585/Include-DMP-logging-in-you-project
    */
    public LogEventLogin(userId: string, regionCode: string): void {
        const properties = this.CreateCustomTelemetryWithMandatoryInfo('User', 'UserLogin',
            'Login', userId, regionCode, true, '');
        const date = new Date();
        properties[`Date`] = date.toISOString();
        this.LogEvent('Login', properties);
    }

    public LogEventLoginAsFailed(userId: string, regionCode: string, errorMessage: string): void {
        const properties = this.CreateCustomTelemetryWithMandatoryInfo('User', 'UserLogin',
            'Login', userId, regionCode, false, errorMessage);
        const date = new Date();
        properties[`Date`] = date.toISOString();
        this.LogEvent('Login', properties);
    }

    private LogEvent(name: string, properties?: { [key: string]: any }): void {
        this.appInsights.trackEvent({ name }, properties);
    }

    private CreateCustomTelemetryWithMandatoryInfo(
        featureName: string, functionName: string,
        areaPath: string, userId: string, regionCode: string,
        isSuccess: boolean, failureReason: string
    ): ICustomProperties {
        const hashedUserId = this.CalculateHash(userId);
        const properties = {
            System: 'GrundRisk',
            Epic: 'GrundRisk',
            Feature: featureName,
            Funktion: functionName,
            AreaPath: areaPath,
            UserIdMD5: hashedUserId,
            User_Organisation: regionCode,
            IsSucces: isSuccess,
            FailureReason: failureReason
        };
        return properties;
    }

    public CalculateHash(input: string): any {
        if (!input || input.length <= 0) {
            return '';
        }
        return Md5.hashStr(input);
    }
}
